import React from 'react';
import Icon from '@amzn/meridian/icon';
import alertKnockoutTokens from '@amzn/meridian-tokens/base/icon/alert-knockout';
import checkKnockoutTokens from '@amzn/meridian-tokens/base/icon/check-knockout';
import closeKnockoutTokens from '@amzn/meridian-tokens/base/icon/close-knockout';

export type AssetStatus = 'APPROVED' | 'PENDING' | 'REJECTED';

export const ASSET_STATUSES: Record<string, AssetStatus> = {
  APPROVED: 'APPROVED',
  PENDING: 'PENDING',
  REJECTED: 'REJECTED',
};

type AssetSectionConfigurationMap = {
  [key in AssetStatus]: {
    sectionIcon:
    | typeof closeKnockoutTokens
    | typeof checkKnockoutTokens
    | typeof alertKnockoutTokens;
    iconColor: 'error' | 'success' | 'warning';
  };
};

const sectionConfiguration: AssetSectionConfigurationMap = {
  APPROVED: {
    sectionIcon: checkKnockoutTokens,
    iconColor: 'success',
  },
  PENDING: {
    sectionIcon: alertKnockoutTokens,
    iconColor: 'warning',
  },
  REJECTED: {
    sectionIcon: closeKnockoutTokens,
    iconColor: 'error',
  },
};

export const AssetStatusIcon = ({
  approvalStatus,
}: {
  approvalStatus: AssetStatus;
}) => (
  <Icon
    color={sectionConfiguration[approvalStatus].iconColor}
    tokens={sectionConfiguration[approvalStatus].sectionIcon}
  />
);

export const iconApproved = <AssetStatusIcon approvalStatus={ASSET_STATUSES.APPROVED} />;
export const iconPending = <AssetStatusIcon approvalStatus={ASSET_STATUSES.PENDING} />;
export const iconRejected = <AssetStatusIcon approvalStatus={ASSET_STATUSES.REJECTED} />;
